module.exports = __webpack_public_path__ + "img/logo-sdn.1a6ca91d.png";